import { render, staticRenderFns } from "./shimmer.vue?vue&type=template&id=7b96c034&scoped=true"
import script from "./shimmer.vue?vue&type=script&lang=js"
export * from "./shimmer.vue?vue&type=script&lang=js"
import style0 from "./shimmer.vue?vue&type=style&index=0&id=7b96c034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b96c034",
  null
  
)

export default component.exports